import ResourcesCollectionProto from "./resources-collection-proto"
import SessionReminderModel from "../../gd-session/reminders/session-reminder-model"
import Resources from "../resources";

export default class RemindersResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, SessionReminderModel, options)
    }
}